// removed by extract-text-webpack-plugin
module.exports = {"title":"_3GK8P8b38tA0CM9-M9HUc","grouptitle":"_19bRkpJlL4-pyAhMvoAirU","group":"_20Ny8z1YP-b_s7_Nw_7iMA","groupitems":"_3U-cnMhIVIaFcEnCPFj6Qu","groupmask":"_358tjPl5pA98xjVed0kyUQ","selected":"_1jm467-PKkuPLF9DKBYOaE"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/SideBar/MenuRed.scss
// module id = ./node_modules/wix-style-react/dist/es/src/SideBar/MenuRed.scss
// module chunks = 0